export const DETAILS_INFO = [
  { id: 'faster-cheaper-transactions' },
  { id: 'security-of-payment' },
  { id: 'control-over-your-funds' },
  { id: 'privacity' },
  { id: 'accessibility' },
  { id: 'price-stability' },
  { id: 'borderless-transactions' },
];
